import { createReducer } from 'deox';
import produce from 'immer';
import { AuthState } from './types';
import {
  clearAuthErrorsAction,
  loginAction,
  setAuthErrorsAction,
  signUpAction,
  sendCodeAction,
  setUserPhoneAction,
} from './actions';

const initialState: AuthState = {
  isLoading: false,
  errors: {
    login: null,
    signUp: null,
    sendCode: null,
  },
  code: '',
  phone: '',
};

export const authReducer = createReducer(initialState, handle => [
  handle(loginAction.request, state =>
    produce(state, draft => {
      draft.isLoading = true;
      draft.errors.login = null;
    }),
  ),
  handle(loginAction.success, state =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors.login = null;
    }),
  ),
  handle(loginAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors.login = payload;
    }),
  ),
  handle(signUpAction.request, state =>
    produce(state, draft => {
      draft.isLoading = true;
      draft.errors.signUp = null;
    }),
  ),
  handle(signUpAction.success, state =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors.signUp = null;
    }),
  ),
  handle(signUpAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors.signUp = payload;
    }),
  ),
  handle(sendCodeAction.request, state =>
    produce(state, draft => {
      draft.isLoading = true;
      draft.errors.sendCode = null;
    }),
  ),
  handle(sendCodeAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.code = payload;
      draft.errors.sendCode = null;
    }),
  ),
  handle(sendCodeAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors.sendCode = payload;
    }),
  ),
  handle(setAuthErrorsAction, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors = payload;
    }),
  ),
  handle(clearAuthErrorsAction, state =>
    produce(state, draft => {
      draft.isLoading = false;
      draft.errors = {
        login: null,
        signUp: null,
        sendCode: null,
      };
    }),
  ),
  handle(setUserPhoneAction, (state, { payload }) =>
    produce(state, draft => {
      draft.phone = payload;
    }),
  ),
]);
